export default "__VITE_ASSET__B_4A31zt__"